import { Button, Panel } from '@watcherr/ui';
import * as React from 'react';
import styled from 'styled-components';
import { t } from '~/i18n';
import GeofenceMap from '../components/GeofenceMap';
import GeofenceMapWrapper from '../components/GeofenceMapWrapper';
import GeofenceSettingsContainer from './GeofenceSettingsContainer';

interface GeofenceCreatorContainerProps {
  siteUuid: string;
  selectedZones: string[];
  onSave: (zones: string[]) => void;
  onCancel: () => void;
}

const GeofenceCreatorContainer: React.FC<GeofenceCreatorContainerProps> = ({
  siteUuid,
  selectedZones,
  onSave,
  onCancel,
}) => {
  const [selectedPlane, setSelectedPlane] = React.useState<string>();
  const [newSelection, setNewSelection] = React.useState<string[]>(selectedZones)


  const handleSave = () => {
    onSave(newSelection)
  }

  return (
    <>
      <Panel.Subtitle>
        {t('geofence.creator.title')}
      </Panel.Subtitle>
      <GeofenceMapWrapper>
        <GeofenceMap
          siteId={siteUuid}
          onPlaneChange={setSelectedPlane}
          selectedPlane={selectedPlane}
          onZonesChange={setNewSelection}
          selectedZones={newSelection}
          isSelectable={true}
        />
        <GeofenceSettingsContainer
          siteUuid={siteUuid}
          selectedPlane={selectedPlane}
          onPlaneChange={setSelectedPlane}
          onZoneSelectChange={setNewSelection}
          show={true}
          selectedZones={newSelection}         
          />
      </GeofenceMapWrapper>
      <ButtonRow>
        <Button onClick={onCancel} buttonType="link">
          {t('global.cancel')}
        </Button>
        <Button onClick={handleSave}>
          {t('geofence.settings.submit')}
        </Button>
      </ButtonRow>
    </>
  );
};

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export default GeofenceCreatorContainer;
